import { ReactNode } from 'react';
import cn from 'classnames';

import Label from './label';
import CTA, { CTAProps } from './cta';

interface ColumnProps {
  children: ReactNode;
  label?: string;
  cta?: CTAProps;
  className?: string;
}

export default function Column({
  children,
  label,
  cta,
  className,
}: ColumnProps) {
  return (
    <div
      className={cn(
        `w-full lg:max-w-[265px] max-w-full flex flex-col justify-between`,
        !label && `mt-4 lg:mt-10`,
        className,
      )}
    >
      <div className="px-2 lg:px-6 lg:py-6">
        {label && <Label className="pb-5 lg:pb-7">{label}</Label>}
        <div className="grid grid-cols-1 space-y-4 lg:space-y-6">
          {children}
        </div>
      </div>
      {cta && (
        <div className="px-3 lg:px-0 mt-4 lg:mt-0 mb-0 lg:mb-6 flex justify-start lg:justify-center">
          <CTA {...cta} />
        </div>
      )}
    </div>
  );
}
